import { uiController } from '@/controllers/uiController'
import { Z_INDEX_MAX } from '@/helpers/commonConsts'
import { userService } from '@/services/userService'
import { Modal } from 'antd'
import { observer } from 'mobx-react'
import { FC } from 'react'
import { BuyTokenPackageDialog } from '../BuyTokenPackageDialog'
import { BuyVipDialogV1 } from '../BuyVipDialogV1'
import ExchangeCodeDialog from '../ExchangeCodeDialog/ExchangeCodeDialog'
import { FeaturePayDialog } from '../FeaturePayDialog/FeaturePayDialog'
import LoginModal from '../LoginModal/LoginModal'
import NewUserDiscountModal from '../NewUserDiscountModal/NewUserDiscountModal'
import OperationRecordModal from '../OperationRecordModal/OperationRecordModal'
import { PayQrDialog } from '../PayQrDialog'
import { PaySuccessDialog } from '../PaySuccessDialog'
import { PaySuccessEducationDiaLog } from '../PaySuccessEducationDiaLog'
import PdfLimitModal from '../PdfLimitModal/PdfLimitModal'
import { RegisterCheckPhoneNumber } from '../RegisterCheckPhoneNumber/RegisterCheckPhoneNumber'
import UserWelcome from '../UserWelcome/UserWelcome'
import style from './CommonDialogLayout.module.less'
import { PayVipUpgradeDialog } from '../PayVipUpgradeDialog/PayVipUpgradeDialog'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    return (
      <div>
        {/* 支付成功弹窗 */}
        <PaySuccessDialog
          onClose={() => {
            uiController.paySuccessDialogProps = { open: false }
            userService.invokePaySuccessfulListener()
          }}
          {...uiController.paySuccessDialogProps}
        ></PaySuccessDialog>
        {/* 教育优惠支付成功弹窗 */}
        <PaySuccessEducationDiaLog
          {...uiController.paySuccessEducationDialogProps}
          onClose={() => {
            uiController.paySuccessEducationDialogProps = { open: false }
          }}
        ></PaySuccessEducationDiaLog>

        {/* 加量包购买弹窗 */}
        {uiController.buyTokenPackageDialogProps.open && (
          <BuyTokenPackageDialog
            paySuccess={() => {
              // 支付成功
              uiController.paySuccessDialogProps = {
                open: true,
                enableGiftReceiveBtn: false,
              }
            }}
            onClose={(isPaySuccessful) => {
              uiController.buyTokenPackageDialogProps = { open: false, source: '' } as any
              if (!isPaySuccessful) {
                // 用户点击关闭
                userService.closePayModalListener?.()
              }
            }}
            {...uiController.buyTokenPackageDialogProps}
          ></BuyTokenPackageDialog>
        )}

        {/* 新版本支付弹窗，仅会员购买 */}
        {uiController.buyVipDialogV1Props.open && (
          <BuyVipDialogV1
            onClose={(isPaySuccessful) => {
              uiController.buyVipDialogV1Props = { open: false, source: '' }
              if (!isPaySuccessful) {
                // 用户点击关闭
                userService.closePayModalListener?.()
              }
            }}
            paySuccess={(enableReceiveGift) => {
              // 支付成功
              uiController.paySuccessDialogProps = {
                open: true,
                enableGiftReceiveBtn: enableReceiveGift,
              }
            }}
            {...uiController.buyVipDialogV1Props}
          ></BuyVipDialogV1>
        )}

        {/* PDF 限制弹窗 */}
        <PdfLimitModal
          {...uiController.pdfLimitModalProps}
          onClose={() => {
            uiController.pdfLimitModalProps = { open: false }
          }}
        ></PdfLimitModal>
        {/* 通用提示弹窗 */}
        <Modal
          zIndex={Z_INDEX_MAX}
          className={style.commonModal}
          centered
          {...uiController.commonModalProps}
        >
          {uiController.commonModalProps.content}
        </Modal>

        {uiController.exchangeDialogProps.open && (
          <ExchangeCodeDialog
            {...uiController.exchangeDialogProps}
            onClose={() => {
              uiController.exchangeDialogProps = { open: false }
            }}
          ></ExchangeCodeDialog>
        )}

        {/* 操作记录弹窗 */}
        <OperationRecordModal
          open={uiController.operationRecordModalVisible}
          onCancel={() => {
            uiController.operationRecordModalVisible = false
          }}
        ></OperationRecordModal>

        {/* 登录弹窗 */}
        {uiController.loginModalProps.open && (
          <LoginModal
            open={uiController.loginModalProps.open}
            showLeftBanner={uiController.loginModalProps.showLeftBanner}
            giftUserProPlus={uiController.loginModalProps.giftUserProPlus}
            onCancelClick={() => {
              uiController.loginModalProps = { open: false }
            }}
            onLoginSuccess={() => {
              uiController.loginSuccess()
            }}
          />
        )}

        {/* 填写手机号码弹窗 */}
        {uiController.showPhoneNumberModal && (
          <Modal
            open={uiController.showPhoneNumberModal}
            width={528}
            footer={null}
            centered={true}
            title={null}
            maskClosable={false}
            styles={{
              content: {
                borderRadius: '28px',
                padding: '32px 76px 24px',
                background: '#fff',
              },
            }}
            onCancel={() => {
              uiController.showPhoneNumberModal = false
              uiController.openDiscountOrClose()
            }}
          >
            <RegisterCheckPhoneNumber
              onSuccess={() => {
                uiController.showPhoneNumberModal = false
                uiController.openDiscountOrClose()
              }}
              showFooterLink={true}
            ></RegisterCheckPhoneNumber>
          </Modal>
        )}

        {/* 新人福利弹窗 */}
        {uiController.showDiscountModal &&
          uiController.discount &&
          uiController.discountEndTime && <NewUserDiscountModal></NewUserDiscountModal>}

        {/* 支付二维码弹窗 */}
        {uiController.showPayQr && uiController.discount && (
          <PayQrDialog
            open={uiController.showPayQr}
            plan={uiController.discount}
            source={uiController.payQrSource}
            from={uiController.showPayQrFrom}
            enableDiscountCode={uiController.enableDiscountCode}
            feature={uiController.feature}
            paySuccess={() => {
              // 支付成功 关闭弹窗
              uiController.showPayQr = false
              uiController.showPayQrFrom = ''
              uiController.showDiscountModal = false
              uiController.enableDiscountCode = false
              uiController.payQrSuccess?.()
              // 支付成功弹窗
              uiController.paySuccessDialogProps = {
                open: true,
                enableGiftReceiveBtn: true,
                onClose: () => {
                  uiController.paySuccessDialogProps = { open: false }
                  // vm.openPdf()
                  uiController.closeLoginModal()
                },
              }
            }}
            onClose={() => {
              uiController.showPayQr = false
              uiController.showPayQrFrom = ''
              uiController.enableDiscountCode = false
              uiController.payQrSuccess = undefined
            }}
          ></PayQrDialog>
        )}

        {/* 注册成功，登录成功弹窗 */}
        {uiController.showUserRegisterSuccessModal && (
          <UserWelcome
            open={uiController.showUserRegisterSuccessModal}
            onClose={() => {
              uiController.showUserRegisterSuccessModal = false
            }}
          ></UserWelcome>
        )}

        {/* 从插件进入定价页的新付费弹窗 */}
        {uiController.payDialogByFeature.open && (
          <FeaturePayDialog
            {...uiController.payDialogByFeature}
            onClose={() => {
              uiController.payDialogByFeature = {
                open: false,
                feature: 'normal',
                vipType: 'max',
                source: '',
                enableDiscountCode: false,
              }
            }}
          ></FeaturePayDialog>
        )}

        {/* 补差价升级弹窗 */}
        {uiController.showPayVipUpgradeDialog.open && (
          <PayVipUpgradeDialog
            onClose={() => {
              uiController.showPayVipUpgradeDialog = {
                open: false,
                source: '',
                planUpgrade: undefined,
              }
            }}
            planUpgrade={uiController.showPayVipUpgradeDialog.planUpgrade!}
            {...uiController.showPayVipUpgradeDialog}
          ></PayVipUpgradeDialog>
        )}
      </div>
    )
  }
)

export default CommonDialogLayout
